import React from "react";
import EN from "../../locales/en";
import { substituteLinkInContent } from "../../utils/switching";
import RadioField from "./partials/RadioField";

const Marketing = ({ supplierTermsInfo, isSubmitting }) => {
  return (
    <div className="mt-8 border-t border-[#afb6b9]">
      <h2 className="text-[30px] font-bold text-primary mt-6">
        {EN.switch.marketing.title}
      </h2>
      <h3 className="text-[22px] font-bold mt-4">
        {EN.switch.marketing.reminder_title}
      </h3>
      <p className="text-md leading-[1.5] mt-2">
        {EN.switch.marketing.reminder_text}
      </p>
      <RadioField
        name="consentInfo.hasConsentSupplierMarketingEmail"
        label={EN.switch.marketing.reminder_yes}
        value="true"
        hideErrorMessage={true}
        disabled={isSubmitting}
      />
      <RadioField
        name="consentInfo.hasConsentSupplierMarketingEmail"
        label={EN.switch.marketing.reminder_no}
        value="false"
        disabled={isSubmitting}
      />

      {supplierTermsInfo?.supplierConsent?.isVisible && (
        <>
          <h3 className="text-[22px] font-bold mt-6">
            {supplierTermsInfo?.supplierConsent?.marketingConsent?.displayText}
          </h3>
          <p className="text-md leading-[1.5] mt-2">
            {substituteLinkInContent(
              supplierTermsInfo?.supplierConsent?.marketingConsent
                ?.privacyPolicy
            )}
          </p>
          <RadioField
            name="consentInfo.hasConsentSupplierTerms"
            label={EN.switch.marketing.consent_yes}
            value="true"
            hideErrorMessage={true}
            disabled={isSubmitting}
          />
          <RadioField
            name="consentInfo.hasConsentSupplierTerms"
            label={EN.switch.marketing.consent_no}
            value="false"
            disabled={isSubmitting}
          />
        </>
      )}
    </div>
  );
};

export default Marketing;
